import  React,{Component} from 'react'
import OtpInput from "react-otp-input";
import ErrorTextContainer from "../errortextcontainer/errortextcontainer";
import Grid from "@material-ui/core/Grid";

 class MFACodeContainer extends Component{

     state={
         code:""
     }

     handleChange = (code) => this.props.setCodeRequestHandler(code);
     render(){
         const {code,errorText,errorStatus,name} = this.props;
         return (
             <Grid>
                 <OtpInput
                     name={name}
                     value={code}
                     autoFocus={false}
                     onChange={this.handleChange}
                     numInputs={6}
                     separator={<span style={{ width: "8px" }}></span>}
                     isInputNum={true}
                     shouldAutoFocus={true}
                     inputStyle={{
                         border: "solid 1.1px #CFD3DB",
                         borderRadius: "8px",
                         width: "41px",
                         height: "53px",
                         fontSize: "12px",
                         color: "#000",
                         fontWeight: "400",
                         caretColor: "blue"
                     }}
                     focusStyle={{
                         border: "2px solid #2e5790",
                         outline: "none"
                     }}
                     errorStyle={{
                         border:"1px solid #d64332",
                         outline: "none"
                     }}
                     isInputSecure
                     isInputNum
                     hasErrored={errorStatus && code ===""}
                 />

                 <Grid item style={{paddingTop:"15px"}}>
                    <ErrorTextContainer text={code ===""?errorText:""}/>
                 </Grid>
            </Grid>
         )
     }


}


export default MFACodeContainer